import { getIq, getIqById, editIq, getQuotationDocument } from '@/api/instant.api'

export const FETCH_IQ = 'FETCH_IQ'
export const FETCH_IQ_LOADING = 'FETCH_IQ_LOADING'
export const FETCH_IQ_DONE = 'FETCH_IQ_DONE'
export const FETCH_IQ_ERROR = 'FETCH_IQ_ERROR'

export const FETCH_IQ_BY_ID = 'FETCH_IQ_BY_ID'
export const FETCH_IQ_BY_ID_LOADING = 'FETCH_IQ_BY_ID_LOADING'
export const FETCH_IQ_BY_ID_DONE = 'FETCH_IQ_BY_ID_DONE'
export const FETCH_IQ_BY_ID_ERROR = 'FETCH_IQ_BY_ID_ERROR'

export const PUT_EDIT_IQ = 'PUT_EDIT_IQ'
export const PUT_EDIT_IQ_LOADING = 'PUT_EDIT_IQ_LOADING'
export const PUT_EDIT_IQ_DONE = 'PUT_EDIT_IQ_DONE'
export const PUT_EDIT_IQ_ERROR = 'PUT_EDIT_IQ_ERROR'

export const DOWNLOAD_QUOTATION_INVOICE = 'DOWNLOAD_QUOTATION_INVOICE'
export const DOWNLOAD_QUOTATION_INVOICE_LOADING = 'DOWNLOAD_QUOTATION_INVOICE_LOADING'
export const DOWNLOAD_QUOTATION_INVOICE_DONE = 'DOWNLOAD_QUOTATION_INVOICE_DONE'
export const DOWNLOAD_QUOTATION_INVOICE_ERROR = 'DOWNLOAD_QUOTATION_INVOICE_ERROR'

export default {
  [FETCH_IQ] (context, {page, filter, itemPerPage}) {
    context.commit(FETCH_IQ_LOADING)
    return getIq(page, filter, itemPerPage)
      .then((response) => {
        context.commit(FETCH_IQ_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_IQ_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_IQ_BY_ID] (context, id) {
    context.commit(FETCH_IQ_BY_ID_LOADING)
    return getIqById(id)
      .then((response) => {
        context.commit(FETCH_IQ_BY_ID_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_IQ_BY_ID_ERROR, error)
        console.error(error)
      })
  },

  [PUT_EDIT_IQ] (context, { id, payload }) {
    context.commit(PUT_EDIT_IQ_LOADING)
    return editIq(id, payload)
      .then((response) => {
        context.commit(PUT_EDIT_IQ_DONE, response)
      })
      .catch((error) => {
        context.commit(PUT_EDIT_IQ_ERROR, error)
      })
  },

  [DOWNLOAD_QUOTATION_INVOICE] (context, { id, fileName }) {
    context.commit(DOWNLOAD_QUOTATION_INVOICE_LOADING)
    return getQuotationDocument({id, fileName})
      .then((response) => {
        context.commit(DOWNLOAD_QUOTATION_INVOICE_DONE, response)
      })
      .catch((error) => {
        context.commit(DOWNLOAD_QUOTATION_INVOICE_ERROR, true)
        console.error(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/instantQuote/actions.js